<!-- 这是顶部菜单tab栏的组件-->
<template>
    <div class="main">
        <div class="tabContent">
            <div :class="divTypeas == '0' ? 'nameColor' : 'nameNoColoe'" @click="handleGe">感恩系列</div>
            <div :class="divTypeas == '1' ? 'nameColor' : 'nameNoColoe'" @click="handleFh">芳华系列</div>
            <div :class="divTypeas == '2' ? 'nameColor' : 'nameNoColoe'" @click="handleXq">乡情系列</div>
            <div :class="divTypeas == '3' ? 'nameColor' : 'nameNoColoe'" @click="handleKy">昆玉系列</div>
        </div>
    </div>
</template>
<script>
export default {
    name: "FixedNavigation",
    props: {
        divTypeas: String
    },
    data() {
        return {
            type: '0',
        }
    },
    components: {},
    created() {

    },
    methods: {
        handleGe() {
            this.$router.push("/GoneDetail")
        },
        handleFh() {
            this.$router.push("/FoneDetail")
        },
        handleXq() {
            this.$router.push("/XoneDetail")
        },
        handleKy() {
            this.$router.push("/KoneDetail")
        },
    }
};
</script>

<style scoped>
.nameNoColoe {
    font-size: 28px;
    font-weight: bold;
    width: 120px;
    padding: 24px;
    text-align: center;
    background-color: #fff;
}

.nameColor {
    width: 120px;
    padding: 24px;
    font-size: 28px;
    font-weight: bold;
    background-color: #1f4fa9;
    color: #fff;
    text-align: center;
}

.tabContent {
    position: fixed;
    right: 0;
    top: 25%;
    z-index: 9999;
}
</style>